import { z } from 'zod'
import { ApiLocale } from '@library/enums'

/** messageList */
export const messageListSchema = z.object({
  /** 語系 */
  lang: z.nativeEnum(ApiLocale),
  /** 訊息 */
  message: z.string()
})

export const errorMessageListSchema = z.object({
  /** 回傳代碼 */
  rtnCode: z.number(),
  /** 訊息陣列 */
  messageList: z.array(messageListSchema)
})

export interface ErrorMessageList
  extends z.infer<typeof errorMessageListSchema> {}
